export default __webpack_public_path__ + "static/media/coinThree.8de724ee.png";